import React from 'react';

/**
 * Dark shimmer placeholder blocks.
 */
export function LoadingSkeleton({ className = '' }) {
  return (
    <div
      className={`animate-pulse rounded-2xl bg-beachvision-surface-low ${className}`}
      aria-hidden
    />
  );
}
